import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { isPresent } from 'utils/isPresent';

import { isProdOrStaging } from '@/indexHelpers';
import ProIdentity from 'components/ProIdentity/ProIdentity';

export const useSetDatadogUserIdentity = (isProFetched: boolean, proData: ProIdentity) => {
  useEffect(() => {
    if (isProdOrStaging()) {
      if (isProFetched && isPresent(proData)) {
        datadogRum.setUser({
          id: proData.id,
          uuid: proData.uuid,
          email: proData.email,
          name: proData.full_name,
          organization_uuid: proData.organization_uuid,
          organization_name: proData.organization_name,
          impersonated: proData.impersonated,
          is_admin: proData.is_admin,
          is_archived: proData.is_archived,
          is_super_pro: proData.is_super_pro,
        });
      }
    }
  }, [isProFetched, proData]);
};
